// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"368":"29521682","381":"ff0cbbee","584":"0f79ba68","638":"0928787e","934":"0f79ba68"}[chunkId] + ".chunk.css";
};